<section class="flex flex-col items-center gap-12">
  <app-section-header
    [description]="
      'An official recommended solution for Capacitor apps as Ionic Appflow transitions'
    "
    [icon]="'@tui.arrow-right-circle'"
    [subtitle]="'Ionic Appflow Migration'"
    [title]="'Alternative to Ionic Appflow'"
  >
  </app-section-header>
  <div class="grid w-full grid-cols-1 gap-8 md:grid-cols-2">
    <div
      class="flex items-center justify-center rounded-[--tui-radius-l] bg-background-neutral-1 p-8 md:p-12"
    >
      <div
        class="flex h-full w-full flex-col items-center justify-center gap-8 rounded-[--tui-radius-m] border-4 border-[#3880FF] bg-gradient-to-br from-blue-50 to-purple-50 p-8"
      >
        <img
          src="/assets/images/logos/appflow.webp"
          alt="Ionic Appflow"
          class="h-auto w-48"
        />
        <div class="flex flex-col items-center">
          <tui-icon icon="@tui.arrow-down" class="text-4xl text-[#3880FF]" />
          <div class="mt-4 flex items-center">
            <img
              class="mr-3 h-11 w-auto rounded-lg"
              src="/assets/logo.svg"
              alt="Capawesome Cloud Logo"
            />
            <span class="text-xl font-bold text-black md:text-2xl"
              >Capawesome Cloud</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col gap-6 p-4">
      <p class="text-pretty text-lg">
        Ionic Appflow is being discontinued. Capawesome Cloud is an official
        recommended alternative — fully bootstrapped and here to stay.
      </p>
      @for (highlight of highlights; track highlight) {
        <div class="flex items-center gap-3">
          <div
            class="flex flex-shrink-0 items-center justify-center rounded-full bg-green-100 p-1"
          >
            <tui-icon icon="@tui.check" class="text-sm text-green-600" />
          </div>
          <p class="text-lg" [innerHTML]="highlight"></p>
        </div>
      }
      <a
        appearance="flat"
        iconEnd="@tui.arrow-right"
        size="xl"
        tuiButton
        type="button"
        [href]="migrationUrl"
        class="mt-2 self-start"
        target="_blank"
        data-umami-event="landing-appflow-section-book-migration-button"
      >
        Book a migration
      </a>
    </div>
  </div>
</section>
